(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cover-notebook-fit"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__aspCoverFitBound) return;
    window.__aspCoverFitBound = true;

    function isCoverFitPopover(target) {
      return target instanceof Element && target.classList.contains('cover-fit__popover');
    }

    function fitNotebookLines(popover) {
      var list = popover.querySelector('.cover-fit__list');
      if (!list) return;
      var minScale = parseFloat(getComputedStyle(list).getPropertyValue('--cover-fit-line-min'));
      if (!(minScale > 0) || minScale > 1) minScale = 0.875;
      list.querySelectorAll('li').forEach(function (li) {
        li.style.fontSize = '';
        li.style.whiteSpace = 'nowrap';
        var room = li.clientWidth;
        if (room < 1) return;
        var need = li.scrollWidth;
        if (need <= room) return;
        var scale = room / need;
        if (scale >= minScale) {
          li.style.fontSize = scale + 'em';
        } else {
          li.style.whiteSpace = '';
        }
      });
    }

    document.addEventListener('dialog:before-show', function (event) {
      if (!isCoverFitPopover(event.target)) return;
      document.documentElement.classList.add('asp-cover-fit-open');
    }, true);

    document.addEventListener('dialog:after-show', function (event) {
      if (!isCoverFitPopover(event.target)) return;
      requestAnimationFrame(function () {
        fitNotebookLines(event.target);
      });
    }, true);

    document.addEventListener('dialog:before-hide', function (event) {
      if (!isCoverFitPopover(event.target)) return;
      document.documentElement.classList.remove('asp-cover-fit-open');
    }, true);

    if (window.ResizeObserver) {
      var observer = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          var popover = entry.target.closest('.cover-fit__popover');
          if (popover && popover.hasAttribute('open')) fitNotebookLines(popover);
        });
      });
      document.querySelectorAll('.cover-fit__list').forEach(function (list) {
        observer.observe(list);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["journal-addon-price"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__aspJournalAddonPriceBound) return;
    window.__aspJournalAddonPriceBound = true;

    function cartHasJournal(cart) {
      var items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        if (String(items[i].product_type || '').indexOf('Leather Journal Covers') !== -1) return true;
      }
      return false;
    }

    function apply(cart) {
      var on = cartHasJournal(cart);
      document.querySelectorAll('[data-asp-journal-addon-price]').forEach(function (el) {
        if (el.getAttribute('data-asp-journal-addon-force') === '1') {
          el.removeAttribute('hidden');
          return;
        }
        if (on) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
    }

    function refresh() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(apply)
        .catch(function () {});
    }

    document.addEventListener('cart:change', function (event) {
      if (event && event.detail && event.detail.cart) apply(event.detail.cart);
      else refresh();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
